import React, { useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { Col, Row } from "../../ApiS/Grid-system/Grid-system";
import parse from "html-react-parser"


interface AccordionProps {
  list?: { link: string; name: string; image?: string, color?: string }[];
  image?: string;
  name: string;
  Register?: boolean;
  Duration_Study?: boolean;
  className?: string;
  fees?: boolean;
  success?: boolean;
  desc ?:string
}

const Accordion: React.FC<AccordionProps> = ({
  list,
  image,
  name,
  Register,
  Duration_Study,
  className,
  fees,
  success,
  desc
}) => {
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false);

  return (
    <div className="">
      <button
        onClick={() => setAccordionOpen(!accordionOpen)}
        className={`flex justify-between items-center w-full gap-3 p-[15px] text-sm py-2 rounded-r-full  hover:bg-white text-black transition-all ${className} ${
          accordionOpen ? "bg-[#FFF1F4]  mb-2" : ""
        }`}
      >
        <div className="flex items-center gap-2 px-[15px]">
          <span className={`text-black font-bold`}>{parse(name!) }</span>
        </div>
        {
          <RiArrowDownSLine
            size={20}
            className={`${
              accordionOpen
                ? "rotate-180 transition-all"
                : "rotate-0 transition-all"
            }`}
          />
        }
      </button>
      <div
        className={`grid overflow-hidden w-[90%] mr-5 transition-all duration-300 ease-in-out text-[#6F757E] text-sm ${
          accordionOpen
            ? "grid-rows-[1fr] opacity-100"
            : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden px-1 border-r-2 space-y-1">
          {list &&
            list?.map((e, i) => (
              <li className="" key={i}>
                <NavLink
                  to={e.link}
                  className="flex items-center gap-3 p-[10px] text-sm py-2 rounded-r-full hover:bg-white text-black"
                  style={{backgroundColor: e?.color}}
                >
                  {/* <img src={e.image} alt={e.name} className="w-[20px] h-[20px]" /> */}
                  <p>{e.name}</p>
                </NavLink>
              </li>
            ))}

          {/* ------------------------------------------ */}
          {/* Information Application Page */}
          {Register && (
            <>
              {parse(desc!) }
            </>
          )}

          {Duration_Study && (
            <>
              <div className="mt-1">
                <ol className="list-decimal">
                  <li className="mt-1">
                    1 - تحدد مدة الدراسة القصوى للطالب في برامج الترقية بـ5
                    سنوات على الأكثر.
                  </li>
                  <li>
                    2 - تحدد مدة الدراسة القصوى للطالب المُتقدم بعد شهادة
                    الدراسة الثانوية في الجامعة بـضعفي الحد الأدنى للدراسة.{" "}
                  </li>
                  <li>
                    3 - يعتبرالطالب المتقدم على أساس الشهادة الثانوية مترفعاً من
                    سنة إلى أخرى، إذا استطاع الحصول على حد أدنى من الوحدات
                    المعتمدة (بما فيها الوحدات الخاصة باللغة الإنكليزية) وفق ما
                    هو مبين في الجدول التالي:
                  </li>
                </ol>
              </div>
              <Row>
                <Col lg={10} md={4} className="mx-auto">
                  <table className="w-full bg-slate-100 lg:w-[800px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
                    <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-t-white">
                      <tr>
                        <td>
                          {" "}
                          الحد الادنى من الوحدات المعتمدة التي يتوجب على الطالب
                          النجاح فيها (من أصل 255 وحدة معتمدة لاختصاص نظم
                          المعلومات وشبكات الاتصال، ومن أصل 253 وحدة معتمدة
                          لاختصاص نظم المعلومات الإدارية)
                        </td>

                        <td>السنة التي سيترفع إليها</td>
                      </tr>
                    </thead>

                    <tbody className="h-[70px]">
                      <tr className="border-2 border-t-white">
                        <td> 25</td>
                        <td> الثانية </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>

              <div>
                ويتم احتساب المستويات التي يعفى منها الطالب في اللغة الإنكليزية
                وفق امتحان تحديد المستوى كجزء من هذا الحد الأدنى، كما يتم احتساب
                الوحدات المعتمدة المكافئة للمقررات التي تم إعفاءه منها كجزء من
                هذا الحد الأدنى وكوحدات معتمدة حصلها الطالب مسبقاً وتدخل في حساب
                الترفيع
              </div>

              <div>
                4 - يعد الطالب المقبول في مسار الثانوية مترفعاً من سنة إلى أخرى،
                إذا حصل على حد أدنى من الوحدات المعتمدة (بما فيها مستويات اللغة
                الإنكليزية) وفق ما هو مبين في الجدول التالي؛ ولا تدخل المستويات
                التي يعفى منها الطالب في اللغة الإنكليزية وفق امتحان تحديد
                المستوى في حساب هذا الحد الأدنى، في حين تدخل الوحدات المعتمدة
                المكافئة للمقررات التي أعفي منها الطالب في حساب هذا الحد الأدنى.
              </div>

              <Row>
                <Col lg={10} md={4} className="mx-auto">
                  <table className="w-full bg-slate-100 lg:w-[800px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
                    <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-t-white">
                      <tr>
                        <td>الحد الادنى من الوحدات المعتمدة</td>

                        <td>السنة التي سيترفع إليها</td>
                      </tr>
                    </thead>

                    <tbody className="h-[70px]">
                      <tr className="border-2 border-t-white">
                        <td> 25</td>
                        <td> الثانية </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </>
          )}

          {fees && (
            <>
              <h1> الأقساط الدراسية في الجامعة بحسب الفصل الدراسي </h1>
            </>
          )}

          {success && (
            <>
              <div className="text-base text-Secondary font-bold mt-2">
                شروط النجاح :
              </div>
              <div className="mt-1"> النجاح في المقرر </div>
              <div className="mt-1">
                {" "}
                1 - تتألف العلامة النهائيّة للمقرّر من جزأين: درجة الامتحان
                الكتابي (لا تقل عن 60%)، ودرجة الأعمال (لا تزيد على 40%) من
                العلامة النهائية للمقرر، وتحدد هذه النسب بقرار من مجلس الشؤون
                العلمية، بما ينسجم مع طبيعة كل مقرّر بناءً على اقتراح مدرس
                المقرر ومجلسي القسم والكلية في مطلع كل فصل دراسي.{" "}
              </div>
              <div className="mt-1">
                {" "}
                2 - يُعد الطالب ناجحاً في المقرر إذا كانت علامته النهائية فيه لا
                تقل عن 60%، بشرط ألاّ تقل درجة أي من الجزأين (الامتحان ودرجة
                الأعمال) عن 40% من العلامة العظمى لكل منهما.{" "}
              </div>
              <div className="mt-1"> النجاح في المشروع </div>

              <div className="mt-1">
                {" "}
                1 - ينجز الطالب مشروعاً في موضوع يقرّه مجلس القسم ضمن التوجه
                الاختصاصي للطالب.{" "}
              </div>
              <div className="mt-1">
                {" "}
                2 - يُنجَز المشروع بإشراف أحد أعضاء الهيئة التعليمية، أو من في
                حكمهم، أو أحد الاختصاصيين ممن يوافق عليه مجلس الشؤون العلمية.{" "}
              </div>
              <div className="mt-1">
                {" "}
                3 - يتم تقييم المشروع من 100 من قبل لجنة حكم مؤلفة من المشرف
                وعضوين من الهيئة التدريسية في الجامعات السورية أو من في حكمهم.{" "}
              </div>
              <div className="mt-1">
                {" "}
                4 - يقدّم الطالب بنتيجة عمله في المشروع تقريراً وعرضاً تقديمياً
                تجري مناقشته أمام اللجنة.{" "}
              </div>
              <div className="mt-1">
                {" "}
                5 - يجري تقويم المشروع وفقاً للقواعد التي يحددها مجلس القسم،
                ويُعَدّ الطالب ناجحاً في المشروع إذا حصل على درجة لا تقل عن 60
                من 100.{" "}
              </div>

              <div className="text-base text-Secondary font-bold mt-2">
                يُشترط لحصول الطالب على درجة الإجازة في تقانة المعلومات ما يأتي
                :
              </div>
              <div className="mt-1"> 1 - أن ينجح في جميع المقرّرات. </div>
              <div className="mt-1"> 2 - أن ينجح في مشروع التخرج. </div>
              <div className="mt-1">
                {" "}
                3 - أن يُسدّد الرسوم والأقساط المالية المترتّبة عليه وفقاً
                للنظام المالي.{" "}
              </div>

              <div className="mt-1">
                -في حال رسوب الطالب في مقرر، يتوجب عليه إعادته كاملاً مع وظائفه
                وامتحاناته، بالإضافة إلى دفع تكاليفه كاملة.
              </div>

              <div className="text-base text-Secondary font-bold mt-2">
                شروط التخرج :
              </div>

              <div className="mt-1">
                1 - يعتبر الطالب متخرجاً وحاصلاً على شهادة الإجازة في تقانة
                المعلومات شريطة النجاح في جميع المقررات المقررة للبرنامج وضمن
                المدة الزمنية المعتمدة.
              </div>

              <div className="mt-1">
                2 - يصدر قرار التخرج من رئاسة الجامعة وتسلم كافة النسخ الورقية
                الخاصة بالبرنامج والنتائج لقسم الامتحانات في الجامعة للحفظ.
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
